<script setup>
import { computed } from 'vue';
import { CORES_STATUS_RELATORIO_DIARIA, ICONES_STATUS_RELATORIO_DIARIA } from '@/commons/projetos';

const props = defineProps({
    valor: String,
});

const cor = computed(() => CORES_STATUS_RELATORIO_DIARIA[props.valor] ?? 'cinza');
const icone = computed(() => ICONES_STATUS_RELATORIO_DIARIA[props.valor]);
</script>

<template>
    <TagBase :valor="valor" :cor="cor" :icone="icone" />
</template>
